import * as React from "react";

export const InterviewNavigationDotSVG = () => {
    return (
        <svg width="8px" height="8px" viewBox="0 0 8 8" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Form" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="CM---Form---1.3.4" transform="translate(-176.000000, -341.000000)" fill="#30D8D7">
                    <g id="LeftPanel" transform="translate(0.000000, 150.000000)">
                        <g id="FormNav" transform="translate(165.000000, 104.000000)">
                            <g id="Household" transform="translate(4.000000, 80.000000)">
                                <circle id="Oval" cx="11" cy="11" r="4" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
